import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Redeem_EarnService } from 'src/app/shared/services/api/redeem-earn.service';
import { UserService } from 'src/app/shared/services/user.service';


@Component({
  selector: 'app-payment-summary-dialog',
  templateUrl: './payment-summary-dialog.component.html',
  styleUrls: ['./payment-summary-dialog.component.scss']
})
export class PaymentSummaryDialogComponent {
  isSuccess:Boolean=true;
  selectedInvoice: any;
  paymentSummaryValues: any;
  conversionRates: any;
  currentDefaultPaymentMethod: any;
  walletDetails;
  ONLpolicyDetails;
  cashPointsEarned;
  achPointsEarned;
  earlyPointsEarned;
  systemError: boolean = false;
  loadingButton: boolean = false;
  walletRole:string='';
  isPPI: boolean = false; 
  ppiInvoiceResponseCode:string='';
  isBilliant: boolean = false; 

  constructor(
    public dialogRef: MatDialogRef<PaymentSummaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private redeemService: Redeem_EarnService,
    private userService: UserService
  ){
    this.walletDetails = this.userService.getWalletDetails();
    this.ONLpolicyDetails = this.userService.getONLSessionDetails();

    this.selectedInvoice = data?.selectedInvoice;
    this.paymentSummaryValues = data?.paymentSummaryValues;
    this.conversionRates = data?.conversionRates;
    this.walletRole=JSON.parse(sessionStorage.getItem('WalletRole'));
    this.currentDefaultPaymentMethod = data?.currentDefaultPaymentMethod
    this.isPPI=data?.isPPI;
    this.isBilliant=sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;

    if (this.paymentSummaryValues?.cash?.input && !this.isPPI) {
      this.cashPointsEarned = Number(this.paymentSummaryValues?.cash?.input * this.conversionRates?.cashBillPayConversion).toFixed(0);
    }

    if (this.paymentSummaryValues?.default?.input && (this.currentDefaultPaymentMethod?.cardType == 'ECP' || this.currentDefaultPaymentMethod?.cardType == 'EC') && !this.isPPI) {
      this.achPointsEarned = Number(this.paymentSummaryValues?.default?.input * this.conversionRates?.achBillPayConversion).toFixed(0);
    }

    if (this.selectedInvoice?.earlyBillPayMessage && !this.isPPI ) {
      this.earlyPointsEarned = Number(this.selectedInvoice?.dueAmount * this.conversionRates?.earlyBillPayConversion).toFixed(0);
    }   
    if (this.selectedInvoice?.earlyBillPayMessage && this.isPPI && this.selectedInvoice.points>0) {
      this.earlyPointsEarned = Number(this.selectedInvoice.points).toFixed(2);
    }  
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    this.systemError = false;
    this.loadingButton = true;
    let request:any;
    let walletRole = JSON.parse(sessionStorage.getItem('WalletRole')!);
    let ONLSessionDetails = JSON.parse(sessionStorage.getItem('WalletRole')!);
    let sessionID = sessionStorage.getItem('SessionID');
    let PPIcustomerID = sessionStorage.getItem('PPICustomerID');
    let PPIuserID = sessionStorage.getItem('PPIUserID');
    if(!this.isPPI){
    request = {
      walletID: this.walletDetails?.walletID,
      walletRole: walletRole,
      invoiceID: this.selectedInvoice?.invoiceNumber,
      productSystem: this.ONLpolicyDetails?.productSystem,
      inProgressRewards: this.paymentSummaryValues?.rewards?.inputInPoints ? Number(this.paymentSummaryValues?.rewards?.inputInPoints) : 0,
      inProgressRewardsValue: this.paymentSummaryValues?.rewards?.input ? Number(this.paymentSummaryValues?.rewards?.input.toFixed(2)) : 0,
      inProgressCashValue: this.paymentSummaryValues?.cash?.input ? Number(this.paymentSummaryValues?.cash?.input.toFixed(2)) : 0,
      paymentValue: this.paymentSummaryValues?.default?.input ? Number(this.paymentSummaryValues?.default?.input.toFixed(2)) : 0, 
      totalInvoiceAmount: Number(this.selectedInvoice?.dueAmount),
      currency: this.walletDetails?.cash?.currency,
      tokenReference: this.currentDefaultPaymentMethod?.token,
      policyNo: this.ONLpolicyDetails?.productSystemIdentifier1,
      pcAccountNo: this.ONLpolicyDetails?.productSystemIdentifier2,
      cardType: this.currentDefaultPaymentMethod?.cardType,
      last4Digits: this.currentDefaultPaymentMethod?.last4Digits,
      ccHolderName: this.currentDefaultPaymentMethod?.ccHolderName,
      ccExpiration: this.currentDefaultPaymentMethod?.ccExpiration,
      cashPointsEarned: this.cashPointsEarned ? this.cashPointsEarned : "0",
      achPointsEarned: this.achPointsEarned ? this.achPointsEarned : "0",
      earlyPointsEarned: this.earlyPointsEarned ? this.earlyPointsEarned : "0",
      sessionID:sessionID,
      billingSystem:this.ONLpolicyDetails?.billingSystem,
      payorID:this.ONLpolicyDetails?.payorID,
    };
    this.redeemService.makeinvoicepayment(request).subscribe(
      data => {
        this.loadingButton = false;
        this.isSuccess=data.success;
        console.log("logging session "+JSON.stringify(data));
        // Not 100% sure what the success response looks like yet, so just putting a default check:
        if (data) {
          this.goToSuccessPage();
        } else {
          this.systemError = true;
        }
      }, error => {
        this.loadingButton = false;
        this.systemError = true;
      }
    )
  }
  else{
    request={
      walletID: this.walletDetails?.walletID,
      walletRole: walletRole,
      invoiceID: this.selectedInvoice?.invoiceID,
      productSystem: "ppi",
      sourceSystemID1:PPIcustomerID,
      userID:PPIuserID,
      inProgressRewards: this.paymentSummaryValues?.rewards?.inputInPoints ? this.paymentSummaryValues?.rewards?.inputInPoints : "0",
      inProgressRewardsValue: this.paymentSummaryValues?.rewards?.input ? this.paymentSummaryValues?.rewards?.input.toFixed(2) : "0",
      inProgressCashValue: this.paymentSummaryValues?.cash?.input ? this.paymentSummaryValues?.cash?.input.toFixed(2) : "0",
      paymentValue: this.paymentSummaryValues?.default?.input ? this.paymentSummaryValues?.default?.input.toFixed(2) : "0", 
      totalPaymentAmount: Number(this.selectedInvoice?.balance).toFixed(2).toString(),
      currency: this.walletDetails?.cash?.currency,
      tokenReference: this.currentDefaultPaymentMethod?.token,
      sessionID:sessionID,
      cvv:this.currentDefaultPaymentMethod?.cvv?this.currentDefaultPaymentMethod?.cvv:"",
      billingSystem:"ppi"
    }
    this.redeemService.makeppiinvoicepayment(request).subscribe(
      data => {
        this.loadingButton = false;
        this.isSuccess=data.success;
        this.ppiInvoiceResponseCode=data.statusLevel;
        // Not 100% sure what the success response looks like yet, so just putting a default check:
        if (data) {
          this.goToSuccessPage();
        } else {
          this.systemError = true;
        }
      }, error => {
        this.loadingButton = false;
        this.systemError = true;
      }
    )
  }

    
  }

  goToSuccessPage() {
    let paidInvoice =  {
      invoiceNumber: !this.isPPI?this.selectedInvoice?.invoiceNumber:this.selectedInvoice.invoiceID,
      cashPointsEarned: this.cashPointsEarned ? this.cashPointsEarned : 0,
      achPointsEarned: this.achPointsEarned ? this.achPointsEarned : 0,
      earlyPointsEarned: this.earlyPointsEarned ? this.earlyPointsEarned : 0,
      isSuccess:this.isSuccess,
      messageCode:this.ppiInvoiceResponseCode
    }

    sessionStorage.setItem('paidInvoice', JSON.stringify(paidInvoice));
    this.dialogRef.close('successful-invoice-paid');
  }
}
